import React, { Component } from "react";
import ReportTable from "./ReportTable";

export default class ReportBaselList extends Component {
  render() {
    return (
      <div className="content">
        <div className="container-fluid">
          <div className="row">
            <ReportTable />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/CAR/Reports/ReportBasel/index.js